import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'shared/components';
import theme from './AccessibilityStatementButton.scss';

const propTypes = {
  intl: PropTypes.bool.isRequired,
  showAccessibilityStatementModal: PropTypes.func.isRequired,
  closePopover: PropTypes.func.isRequired,
};

const AccessibilityStatementButton = ({
  intl,
  showAccessibilityStatementModal,
  closePopover,
}) => (
  <Button
    className={ theme.root }
    testId="accessibility-statement-button"
    buttonType="naked"
    label={ intl.formatMessage({ id: 'AccessibilityStatementDialog.Title', defaultMessage: '** Accessibility statement' }) }
    size="small"
    onClick={ () => {
      showAccessibilityStatementModal();
      closePopover();
    } }
  />
);

AccessibilityStatementButton.propTypes = propTypes;

export default AccessibilityStatementButton;
